import axios from 'axios';
import { clearSession, expireSession } from './session';

const API_URL = process.env.REACT_APP_API_URL;

const api = axios.create({
  baseURL: API_URL,
});

// request interceptor to attach token
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
}, (error) => Promise.reject(error));

// optional: handle 401 globally
api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      const code = err.response.data?.code;
      // Server-reported session expiry: send the user to login with a one-time notice
      if (code?.startsWith('SESSION_')) {
        expireSession(code === 'SESSION_IDLE_EXPIRED' ? 'idle' : 'expired');
      } else {
        clearSession();
      }
    }
    return Promise.reject(err);
  }
);
export const get = api.get;
export const post = api.post;
export const put = api.put;
export const del = api.delete;

export default api;
